import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function promptsFetch(requestor) {
  return createReduxPromiseAction(ActionTypes.PROMPTS_FETCH, organisationId =>
    requestor
      .get(`${basePath}/organisation/${organisationId}/prompt`, {
        withCredentials: true,
      })
      .then(response => {
        return response.data;
      }),
  );
}
